document.addEventListener(
  "DOMContentLoaded",
  function () {
    class InfiniteScroll extends HTMLElement {
      constructor() {
        super();
        this.initMainCollection(this);
        this.submitButton = this.querySelector(".loading-overlay__spinner");
      }

      hideElement(element) {
        element.style.display = "none";
      }

      initMainCollection(section) {
        if (window.IntersectionObserver) {
          this.setupInfiniteScroll(section);
        }
      }

      addLoader() {
        this.querySelector(
          ".infinite-scroll__target .loading-overlay__spinner"
        ).classList.remove("hidden");
      }

      removeLoader() {
        this.querySelector(
          ".infinite-scroll__target .loading-overlay__spinner"
        ).classList.add("hidden");
      }

      setupInfiniteScroll(section) {
        const variantSwatches = document.querySelectorAll(
          ".card__color-swatch-button"
        );

        const nextButton = section.querySelector(".pagination__item--next");
        const pagination = section.querySelector(".pagination-wrapper");
        const target = section.querySelector(".infinite-scroll__target");

        // When infinite scroll is active, pagination
        // buttons should stay hidden
        if (pagination instanceof HTMLElement) {
          this.hideElement(pagination);
        }

        // Grap url of next page from the button href
        let nextPageUrl;
        if (nextButton instanceof HTMLAnchorElement) {
          nextPageUrl = nextButton.href;
        }

        // If there is no next page link, there is no work to be done.
        if (!nextPageUrl) {
          return;
        }

        const observer = new IntersectionObserver((entries, observer) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            // Unsubscribe right away
            observer.unobserve(entry.target);
            // do something
            let boundRenderNextSection = renderNextSection.bind(this);
            boundRenderNextSection();
          }
        });

        observer.observe(target);

        this.addLoader();

        async function renderNextSection() {
          // Fetch main-collection section from next page
          let nextPageSectionHtml;
          try {
            const response = await fetch(
              nextPageUrl + "&section_id=main-collection-product-grid"
            );
            const data = await response.text();
            nextPageSectionHtml = new DOMParser()
              .parseFromString(data, "text/html")
              .querySelector("#ProductGridContainer").innerHTML;
          } catch (err) {
            console.error(err);
          }
          // If server returns nothing, leave.
          if (!nextPageSectionHtml) return;

          this.removeLoader();

          // Insert section HTML after the current section
          section.insertAdjacentHTML("afterend", nextPageSectionHtml);
          const nextPageSection = section.nextElementSibling;

          if (nextPageSection instanceof HTMLElement) {
            // Setup infinite scroll on the next section
            this.setupInfiniteScroll(nextPageSection);
          }
        }
      }
    }

    customElements.define("infinite-scroll", InfiniteScroll);
  },
  false
);
